const Terms = () => {
  return <></>;
};

export default Terms;
